export default {
  "app_label": "geo",
  "model_name": "province",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "data_type": "str",
    },
    {
      "name": "name",
      "label": "Name",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "ellipsis": true,
      "search": true,
      "sort": true
    },
    {
      "name": "code",
      "label": "Code",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "str",
      "search": true,
      "sort": true
    },
    {
      "name": "country",
      "label": "Country",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "name",
      "search": false,
      "sort": false
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": true
    }
  ],
  "filter_by": [
    {
      "label": "Country",
      "name": "country",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:geo:country:autocomplete",
        "key": "pk",
        "display": "name",
        "pagination": true
      }
    },
  ],
  "export_import": null
}